import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Storage, Broker, Platform } from '@c4/core';
import { C4InputConfig, UIModule } from '@c4/ui';

import { Http, ResponseContentType, Headers } from '@angular/http';

import { SysmanComponentBase, IOnBrokerConnectedInit } from '../sysman/sysman.component';
import { ConnectedDeviceService, VersionsService, LogService } from '../services';
import * as moment from 'moment';

declare var saveAs: any; // saveAs JS library

@Component({
  selector: 'sysman-log-config',
  templateUrl: './sysman-log-config.component.html',
  styleUrls: ['./sysman-log-config.component.less']
})
export class SysmanLogConfigComponent extends SysmanComponentBase implements OnInit,IOnBrokerConnectedInit {

  showNoLogsMsg: boolean;
  logErrorMsg: string;
  
  allLogs : Array<any>;
  allLogLevels : Array<any>;
  brokerLogLevels: Array<any>;

  private processDescriptions: {[index:string]: any} = require('!json-loader!../assets/data/process-descriptions.json');

  constructor(private store: Store<any>, private router: Router, private route: ActivatedRoute, 
              private storage: Storage, private platform: Platform,
              private httpService: Http,
              private broker: Broker, private versionsService: VersionsService, 
              private connectedDeviceService: ConnectedDeviceService,
              private logService: LogService) { 
    super(router, route, store, broker, platform, connectedDeviceService, versionsService);
    this.showNoLogsMsg = false;
    this.logErrorMsg = "";
    this.allLogs = [];
    this.allLogLevels = [{name:"fatal",value:"fatal"},
                        {name:"error",value:"error"},
                        {name:"warning",value:"warning"},
                        {name:"info",value:"info"},
                        {name:"debug",value:"debug"},
                        {name:"trace",value:"trace"},
                        {name:"default",value:"default"}];

    this.brokerLogLevels = [
                        {name:"",value:""},
                        {name:"error",value:"error"},
                        {name:"warning",value:"warning"},
                        {name:"info",value:"info"},
                        {name:"verbose",value:"verbose"}];

    super.setBrokerInit(this.onBrokerConnectedInit); // method to call on broker init
  }

  ngOnInit() {
    super.OnInit();
    this.showNoLogsMsg = false;
  }

  ngOnDestroy() {
    this.allLogs = [];
    super.destroy();
  }

  onBrokerConnectedInit() {
      if (this.allLogs.length == 0)
        this.getLogging();
  }

  getLogging() {
    this.connectedDeviceService.setWorking(true);

    this.connDevice.take(1).subscribe(conn => {
      this.logService.getLogs(((conn.connectedDevice.address != this.brokerHost) ? conn.connectedDevice.address : null)).then(
          (data:any) => {
                this.connectedDeviceService.setWorking(false);
                console.log('in getLogging()', data);
                // if an empty array is returned - device doesn't support logging
                if (data && (data.length == 0))
                  this.showNoLogsMsg = true;
                else {
                  var logs = [];
                  // only add broker log if sysman is connected to broker host
                  if (conn.connectedDevice.address == this.brokerHost) {
                    logs.push({
                      name:"broker",
                      level:"",
                      status:"",
                      appender:"",
                      destination:"/var/log/debug/broker.log",
                      type:"program"
                    });
                    this.getBrokerLogLevel();
                  }
                  // deal with multiple entries of logs in returned data
                  data.forEach(log => {
                    
                    // ignore alerts log
                    if (log.logger == "alerts")
                      return;

                    // find previous log entry of same name
                    var findLogs = logs.filter(logentry => {
                      return (logentry.name == log.logger);
                    });
                    if (findLogs.length > 0) {
                      // use alert level from type="program" entry
                      if (log.type == "program") {
                        findLogs[0].type = "program";
                        findLogs[0].level = log.level;
                      }
                      else
                      if ((log.type == "syslog") && (findLogs[0].destination.indexOf("/var")==-1)) {
                        findLogs[0].destination = log.destination;
                      }
                    }
                    else { // not a dupe entry
                      // check if destination is specified
                      if ((log.type == "program") && (log.destination.indexOf("/var")==-1)) {
                        log.destination = "";
                      }
                      logs.push({
                        name:log.logger,
                        level:log.level,
                        status:log.status,
                        appender:log.appender,
                        destination:log.destination,
                        type:log.type
                      });
                    }
                  }); 
                  logs = logs.sort((a,b) => { if (a.name > b.name) return 1; if (b.name > a.name) return -1; return 0; });
                  this.allLogs = logs;
                }
              }, 
              (err:any) => {
                this.connectedDeviceService.setWorking(false);
                console.error('getLogging() error:  ', err);
              });
    }); 
  }

  getBrokerLogLevel() {
    this.connectedDeviceService.setWorking(true);
    this.connDevice.take(1).subscribe(conn => {
      this.logService.getBrokerLogLevel(((conn.connectedDevice.address != this.brokerHost) ? conn.connectedDevice.address : null)).then(
          (data:any) => {
                this.connectedDeviceService.setWorking(false);
                console.log('in getBrokerLogLevel()', data);
                var findBrokerLog = this.allLogs.filter(logentry => {
                  return (logentry.name == "broker")
                });
                if (findBrokerLog.length > 0)
                  findBrokerLog[0].level = data.level
              },
              (err:any) => {
                this.connectedDeviceService.setWorking(false);
                console.error('getBrokerLogLevel() error: ', err);
              });
    });
  }

  // navigate to log view page
  viewLog(log : any) {
    console.log("Viewing log", log);
    this.router.navigate(['../../sysman/viewlog'], {relativeTo: this.route, queryParams: {file:log.destination}});
  }
  
  onChangeLogLevel(event: any, log : any) {
    console.log("Changed Log Level of ", log.name, " to:", event.target.value);
    this.connectedDeviceService.setWorking(true);
      // only enabled on broker host
      if (log.name == "broker") {
          this.logService.setBrokerLogLevel(log.level).then(
              (result: any) => {
                  console.log('in broker onChangeLogLevel()', result); 
                  this.connectedDeviceService.setWorking(false);
              },
              (err:any) => {
                  console.error('in broker onChangeLogLevel() error: ', err);
                  this.connectedDeviceService.setWorking(false);
              });
      }
      else { // all other logs
            this.connDevice.take(1).subscribe(conn => {

              this.logService.setLogLevel(log.name, log.level, ((conn.connectedDevice.address != this.brokerHost) ? conn.connectedDevice.address : null)).then(
                  (result: any) => {
                      console.log('in onChangeLogLevel()', result); 
                      this.connectedDeviceService.setWorking(false);
                  },
                  (err:any) => {
                      console.error('onChangeLogLevel() error: ', err);
                      this.connectedDeviceService.setWorking(false);
                  });
            });
      }
  }

  // check for controller version < 2.10
  isVersionBefore210(version? : string) {
    if ((!version) || (version == ""))
      return false;    
    return (this.versionsService.compareVersions(version,'2.10') < 0);
  }

  onClickDownloadLogs() {
    this.logErrorMsg = "";
    this.connectedDeviceService.setWorking(true);
    console.log('onClickDownloadLogs()');

    this.connDevice.take(1).subscribe(conn => {
      this.httpService.get("https://" + conn.connectedDevice.address + "/api/v1/sysman/snapshot?JWT=" + this.storage.get('authToken'), 
          { responseType: ResponseContentType.Blob,
            headers: new Headers({'Content-type': 'application/json'})}
        ).subscribe(
            (response) => {
              this.connectedDeviceService.setWorking(false);
              var blob = new Blob([response.blob()], {type: 'application/zip'});
              var filename = 'snapshot-' + moment().format('YYYY-MM-DD-HH-m-s') + '.zip';
              // get the filename from response
              response.headers.forEach(o => {
                if (o[0] && (o[0].indexOf("filename=") > -1))
                  filename = o[0].substring(o[0].indexOf("filename=") + 9);
              });
              // use file-saver saveAs library
              saveAs(blob, filename);
        },
        err => {
            console.error('onClickDownloadLogs() error: ', err);
            this.connectedDeviceService.setWorking(false);
            if (err.statusText)
              this.logErrorMsg = err.statusText;
            else
              this.logErrorMsg = "Unknown Error";
        }
      );

      // let browser handle download of file
      // window.open("https://" + conn.connectedDevice.address + "/api/v1/sysman/snapshot?JWT=" + this.storage.get('authToken'), "_blank", "location=0,menubar=0");      
    });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-log-config/sysman-log-config.component.ts